import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/utils/cn";
import { Spinner } from "@/components/ui/modal";

function SkeletonItem() {
  return (
    <div className="flex items-center space-x-2 p-4 pl-4">
      <Skeleton className="h-6 w-6 rounded-sm" />
      <Skeleton className="h-5 w-full rounded-sm" />
    </div>
  );
}

function CreationSidebarSkeleton({ className }: { className?: string }) {
  return (
    <aside
      className={cn(
        "flex flex-col p-4 w-80 h-full bg-sidebar-background border-r border-sidebar-border",
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center mt-3 mb-5 px-2">
        <Skeleton className="h-10 w-10 rounded-full mr-2" />
        <Skeleton className="h-6 w-24 rounded-sm" />
      </div>

      {/* New Project Button */}
      <div className="px-2">
        <Skeleton className="h-10 w-full mb-5 rounded-sm" />
      </div>

      {/* Folders Section */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-4 mx-1.5 px-2">
          <Skeleton className="h-5 w-20 rounded-sm" />
          <Skeleton className="h-5 w-5 rounded-sm" />
        </div>
        <div className="flex items-center justify-start space-x-2 mb-2 mx-1.5 px-2">
          <Skeleton className="h-5 w-5 rounded-sm" />
          <Skeleton className="h-5 w-20 rounded-sm" />
        </div>
        <SkeletonItem />
        <div className="ml-4">
          <SkeletonItem />
          <SkeletonItem />
        </div>
        <SkeletonItem />
      </div>

      {/* Projects Section */}
      <div>
        <div className="flex items-center justify-between mb-2 mx-2 px-2">
          <Skeleton className="h-5 w-20 rounded-sm" />
          <Skeleton className="h-5 w-5 rounded-sm" />
        </div>
        <SkeletonItem />
        <SkeletonItem />
      </div>
    </aside>
  );
}

export function CreationSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn("flex w-full h-full", className)}>
      <CreationSidebarSkeleton />
      <div className="flex-1 flex justify-center items-center gap-8 text-i-primary">
        <Spinner size={48} />
      </div>
    </div>
  );
}
